<ng-content></ng-content>

<ng-container *ngIf="!userAgent.isMobile(); else mobilePicker">
  <div [formGroup]="formGroupDesktop" class="picker">

    <input formControlName="hours"
      type="text"
      pattern="[0-9]*"
      [class.invalid]="hours.invalid && (hours.dirty || hours.touched) || errors">
    &nbsp;
    :
    &nbsp;
    <input formControlName="minutes"
      type="text"
      pattern="[0-9]*"
      [class.invalid]="minutes.invalid && (minutes.dirty || minutes.touched) || errors">

  </div>
</ng-container>

<ng-template #mobilePicker>
  <label [attr.for]="uniqueId" class="is-overlay"></label>

  <div [formGroup]="formGroupMobile" class="picker">
    <input type="time" formControlName="time" [attr.id]="uniqueId">
    <app-text [text]="time.value"></app-text>
    <app-icon *ngIf="time.invalid && (time.dirty || time.touched)"
      class="is-danger text-24" name="error">
    </app-icon>
    <app-icon name="chevron-right"></app-icon>
  </div>

</ng-template>
